import { render, staticRenderFns } from "./SopManual.vue?vue&type=template&id=1fa12317&scoped=true&"
import script from "./SopManual.vue?vue&type=script&lang=js&"
export * from "./SopManual.vue?vue&type=script&lang=js&"
import style0 from "./SopManual.vue?vue&type=style&index=0&id=1fa12317&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa12317",
  null
  
)

export default component.exports